var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.15606 26.9834H8.8091V13.2546L0.733337 7.19775V24.5606C0.733337 25.9012 1.81953 26.9834 3.15606 26.9834Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1909 26.9834H33.8439C35.1845 26.9834 36.2667 25.8972 36.2667 24.5606V7.19775L28.1909 13.2546",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1909 2.75626V13.2547L36.2667 7.19793V3.96762C36.2667 0.971518 32.8466 -0.736505 30.4521 1.06035",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80908 13.2548V2.75635L18.5 10.0245L28.1909 2.75635V13.2548L18.5 20.523",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.733337 3.96762V7.19793L8.8091 13.2547V2.75626L6.54788 1.06035C4.14938 -0.736505 0.733337 0.971518 0.733337 3.96762Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 35.5333,
    height: 26.65,
    fill: "white",
    transform: "translate(0.733337 0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmail_icon.092ea1399aa5678b0d9291ce84578a84.svg";
export { ForwardRef as ReactComponent };